import { useSeatingChart } from './SeatingChart.hooks';
import { useSectionHighlight } from '../../components/hooks/useSectionHighlight';
import { Badge, Group, Text, UnstyledButton } from '@mantine/core';
import classes from './SeatingChart.module.css';
import { BrokerNerdsBarkerCoreModelsMarketplacesSeatingChartCategory } from '../../api/models/brokerNerdsBarkerCoreModelsMarketplacesSeatingChartCategory';

interface CategoryItemProps {
  category: BrokerNerdsBarkerCoreModelsMarketplacesSeatingChartCategory;
}

export function CategoryItem({ category }: CategoryItemProps) {
  const {
    form,
    onSectionClick,
    allSectionsInSeatingChart,
  } = useSeatingChart('form', 'onSectionClick', 'allSectionsInSeatingChart');
  const selectedCategories = form.getValues().sectionIds ?? [];
  const isSelected = selectedCategories.some(sc => sc === category.name.toLowerCase());
  const { highlightSection, unhighlightSection } = useSectionHighlight(category.name);
  const categoryName = category.name.toLowerCase();
  return (
    <UnstyledButton
      onMouseOut={() => unhighlightSection()}
      onMouseOver={() => highlightSection()}
      className={classes.categoryItem}
      data-selected={isSelected}
      key={category.name}
      onClick={() => {
        const sections = category.sections.length < 2
          ? [categoryName]
          : [
            categoryName,
            ...category.sections
              .map(s =>
              category.sectionId !== s
                ? `${categoryName}_${s.toLowerCase().replaceAll('-', ' ')}`
                : s
              ).filter(mappedSection => allSectionsInSeatingChart.includes(mappedSection)),
          ];
        onSectionClick(sections);
      }}
      style={{
        '--category-color': category.color,
      }}
    >
      <Group justify="space-between" w="100%">
        <Text>
          {category.name}
        </Text>
        <Badge
          variant="filled"
          bg="var(--colors-gray-3)"
          c="var(--colors-text)"
          radius="xl"
          size="sm"
        >
          {category.sections.length}
        </Badge>
      </Group>
    </UnstyledButton>
  );
}
